export default "/images/7b0fc7e0d2065a8a8880abe36f403519.avif";